// Note: equals StyledIconButton.height + Stack.borderTop
export const NAVIGATION_BAR_HEIGHT = 64

// const unseenCount = useWorkspacesUnseenCount()
// <StyledBadge
//   badgeContent={count > 99 ? `${toLocale(99)}+` : toLocale(count)}
//   active={active}
//   invisible={!count}
// >
//   <AvatarBase
//     sx={{
//       border: '1px solid #0000001A',
//     }}
//     size={AvatarSize._3XS}
//     src={avatarSrc}
//   />
